import { Col, Row } from "antd";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ScaleContext from "../../../../context/scale/context";
import Form from "../../../form-components/from";
import FieldBuilder from "../../../form-components/field-builder";
import { INITIAL_PAGE } from "../../../../utils/helpers/constants";
import {
  ScaleMovementAction,
  ScaleMovementReason,
  getScaleMovementAction,
  getScaleMovementReason,
} from "../../../../models/scale/enum";

interface IProps {}

const ScaleMovementsFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, movementsQuery } = useContext(ScaleContext);

  const actionOptions = [
    ScaleMovementAction.ATTACH,
    ScaleMovementAction.DETACH,
    ScaleMovementAction.MOVE,
  ].map((action) => ({ label: t(getScaleMovementAction(action)), value: action }));

  const reasonOptions = [
    ScaleMovementReason.MANUAL,
    ScaleMovementReason.PRODUCT_DELETED,
    ScaleMovementReason.PRODUCT_DEACTIVATED,
    ScaleMovementReason.PRODUCT_DEACTIVATED_IN_STORE,
    ScaleMovementReason.PRODUCT_UNWEIGHED,
    ScaleMovementReason.MOVED_TO_ANOTHER_SCALE,
    ScaleMovementReason.STALE_ROW_CLEANUP,
  ].map((reason) => ({ label: t(getScaleMovementReason(reason)), value: reason }));

  return (
    <Form
      formId="scale-movements-filter"
      onSubmit={(data) => {
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: movementsQuery?.perPage,
          keyword: movementsQuery?.keyword,
          filters: [
            data?.hotkey
              ? { name: "hotkey", value: data.hotkey, operation: "eq" }
              : undefined,
            data?.action
              ? { name: "action", value: data.action, operation: "eq" }
              : undefined,
            data?.reason
              ? { name: "reason", value: data.reason, operation: "eq" }
              : undefined,
          ].filter((f) => f),
        };
        actions.setMovementsQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="hotkey"
            label={`${t("hotkey")}`}
            width="large"
            input={{ type: "number" }}
          />
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="action"
            label={`${t("action")}`}
            width="large"
            input={{ type: "select", options: actionOptions }}
          />
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="reason"
            label={`${t("reason")}`}
            width="large"
            input={{ type: "select", options: reasonOptions }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default ScaleMovementsFilter;
